import React from 'react';
import { LoginLayout } from 'layout';
import '@isyc-react/design/main';
import 'assets/css/login.css';
import { RegisterForm } from 'common/auth/modules/pods/login/register';
export const RegisterScene = () => {
    return (React.createElement(LoginLayout, { isRegister: true },
        React.createElement(RegisterForm, null)));
};
